'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _conversationsMap = require('../threads/reducers/conversationsMap');

var _conversationsMap2 = _interopRequireDefault(_conversationsMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  conversationsMap: _conversationsMap2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/conversationsVisitor.js
// module id = 1277
// module chunks = 3